import { useMutation } from '@tanstack/react-query';
import { OrganizationModel } from '../domain';
import { organizationsRepo } from '@/constants/providers';

export const useUpdateOrganization = () =>
  useMutation<OrganizationModel, unknown, FormData>((data) =>
    organizationsRepo.updateOrganization(data),
  );
